module.exports = __webpack_public_path__ + "static/media/github-cli-screenshot.f9601309.png";